/**
 * Keeps the service worker fresh: checks for updates on focus and periodically,
 * and reloads once when a new worker takes control after the first activation (new deploy).
 */

const SS_KEY = 'kissariti-sw-saw-controller';

let reloadScheduled = false;

function reloadOnce(): void {
  if (reloadScheduled) return;
  reloadScheduled = true;
  window.location.reload();
}

export function registerServiceWorkerLifecycle(): void {
  if (!('serviceWorker' in navigator)) return;
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') return;

  let registration: ServiceWorkerRegistration | null = null;

  const checkForUpdates = () => {
    registration?.update().catch(() => {});
  };

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        registration = reg;

        navigator.serviceWorker.addEventListener('controllerchange', () => {
          const seen = sessionStorage.getItem(SS_KEY);
          sessionStorage.setItem(SS_KEY, '1');
          if (!seen) return;
          reloadOnce();
        });

        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') checkForUpdates();
        });

        window.addEventListener('focus', checkForUpdates);

        setInterval(checkForUpdates, 45 * 60 * 1000);

        checkForUpdates();

        console.log('SW registered:', reg);
      })
      .catch((registrationError) => {
        console.log('SW registration failed:', registrationError);
      });
  });

  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'NAVIGATION_ERROR') {
      caches.keys().then((names) => Promise.all(names.map((n) => caches.delete(n)))).then(() => reloadOnce());
    }
  });
}
